"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BULK_UPDATE_PRIORITY_TASKS = void 0;
const gql_1 = require("../../../__generated__/gql");
exports.BULK_UPDATE_PRIORITY_TASKS = (0, gql_1.gql)(`
  mutation BulkUpdatePriorityTasks($input: BulkUpdatePriorityTasksInput!) {
    bulkUpdatePriorityTasks(input: $input) {
      clientMutationId
      updatedCount
      error
    }
  }
`);
